import React from 'react';
import './index.scss';
import {
    SuccessFeedbackScreen,
    ButtonPrimary,
    ErrorFeedbackScreen,
    skinVars,
    useWindowSize,
} from '@telefonica/mistica';
import { Trans, useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { useBillsContext } from '../../../../../context/bills-context/BillsContext';
import { getEnv } from '../../../../../utils/dataTransformation/environments';

export const FeedbackClaimOpening: React.FC = () => {
    const { t } = useTranslation();
    const contactWhatsapp = getEnv('VITE_WEBVIEW_NUMBER_CONTACT_WHATSAPP') as string;
    const { resetClaimValues, claimComment } = useBillsContext();
    const { state } = useLocation();
    const { successFeedback, err, claimCode } = state;
    const message = `Hola, he intentado abrir una reclamación desde la app Mi O2, pero no se ha tramitado. Me gustaría que pudierais ayudarme desde aquí.\n${claimComment}`;

    const navigate = useNavigate();
    const size = useWindowSize();

    const navigationHandler = () => {
        navigate('/bills');
        resetClaimValues();
    };

    const openWhatsAppHandler = () => {
        window.open(`https://wa.me/${contactWhatsapp}?text=${encodeURIComponent(message)}`, '_blank');
    };

    return (
        <div
            className='feedback-claim-opening'
            style={{
                background: successFeedback
                    ? size.width < 1024 || size.height < 550
                        ? skinVars.colors.backgroundBrand
                        : ''
                    : skinVars.colors.background,
            }}
        >
            {successFeedback ? (
                <SuccessFeedbackScreen
                    title={t('claimOpeningFeedbackTitle')}
                    description={t('claimOpeningFeedbackDescription', { claimCode })}
                    primaryButton={
                        <ButtonPrimary onPress={navigationHandler}>{t('buttonUnderstoodFeedback')}</ButtonPrimary>
                    }
                />
            ) : (
                <ErrorFeedbackScreen
                    title={t('claimOpeningErrorFeedbackTitle')}
                    // @ts-ignore
                    description={
                        <Trans
                            i18nKey='claimOpeningErrorFeedbackDescription'
                            components={{
                                ac: (
                                    <span
                                        onClick={openWhatsAppHandler}
                                        style={{
                                            textDecoration: 'underline',
                                            cursor: 'pointer',
                                            color: skinVars.colors.textLink,
                                            fontFamily: 'OnAir',
                                        }}
                                    />
                                ),
                            }}
                        />
                    }
                    errorReference={'Código de error: ' + `${(err as any)?.id}`}
                    primaryButton={
                        <ButtonPrimary onPress={navigationHandler}>{t('buttonUnderstoodFeedback')}</ButtonPrimary>
                    }
                />
            )}
        </div>
    );
};

export default FeedbackClaimOpening;
